module.exports = __webpack_public_path__ + "static/media/Aileen@3x.810f657b.png";